<template>
    <div v-if="discount && discount.Name" class="discount-field">
        <div v-if="title" class="discount-field-title">
            <strong>{{ title }}</strong>
        </div>

        <div class="discount-field-fields">
            <span class="discount-field-fields-label">
                <Translation :translate="{ key: 'shared.apply_deal_code' }" />:
                <strong>{{ code }}</strong>
            </span>
            <Switch
                v-model="discount.IsApplied"
                density="compact"
                :onChange="onToggleDiscount" />
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, computed, ref } from 'vue';
    import { useStore } from '@/store';
    import { AnyProduct } from '@shared/interfaces/product';
    import { AppliedDiscount, ProductType } from '@/api/Cart/cart.interfaces';
    import { logStatsigCheckoutAppliedDiscountInteraction } from '@/tracking/statsig/checkout.functions';
    import Switch from '@ui/components/FormV2/Fields/Switch/Switch.vue';
    import Translation from '@ui/components/Translation/Translation.vue';

    export default defineComponent({
        name: 'AppliedDiscountField',
        methods: { t },
        components: { Translation, Switch },
        props: {
            productId: { type: String, required: true },
        },
        setup(props) {
            const store = useStore();

            const product = computed<AnyProduct>(() =>
                store.getters['cart/getProduct'](props.productId)
            );

            const discount = computed<AppliedDiscount | null>(
                () => product.value?.AppliedDiscount
            );

            const title = computed<string | undefined>(() => {
                switch (product.value?.Type) {
                    case ProductType.Hotel:
                        return undefined; // To be decided...
                    default:
                        return undefined;
                }
            });

            const showValidCheck = computed<boolean>(
                () => discount.value?.Name === code.value
            );

            const code = ref<string | undefined>(discount.value?.Name);

            function onToggleDiscount() {
                logStatsigCheckoutAppliedDiscountInteraction(
                    'OnToggle',
                    product.value.AppliedDiscount?.IsApplied ? code.value : ''
                );
            }

            return {
                title,
                code,
                discount,
                showValidCheck,
                onToggleDiscount,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './AppliedDiscountField.scss';
</style>
